module.exports = __webpack_public_path__ + "static/media/load-loadin1g.aa390ded.gif";